import Masonry from 'masonry-layout';
import InfiniteScroll from 'infinite-scroll';
import imagesLoaded from 'imagesloaded';

$(function () {
	var grid = $(".grid");

	if (grid.length > 0) {

		var msnry = new Masonry('.grid', {
			itemSelector: ".grid-item",
			columnWidth: ".grid-sizer",
			percentPosition: true,
			horizontalOrder: false
		});

		imagesLoaded('.grid', function () {
			msnry!.layout();
		});

		var scroll = new InfiniteScroll('.grid', {
			path: "a#more",
			append: ".grid-item",
			outlayer: msnry
		});

		(<any>window).imagesLoaded = imagesLoaded;
	}

	var convModal = $("div#conversation");
	if (convModal.length > 0) {
		convModal.on("show.bs.modal", function (event) {
			var ahref = $(event.relatedTarget);

			var modal = $(this);
			modal.find(".modal-title").text(ahref.data("subject"));
			modal.find(".modal-body").html("Loading...");

			$.get(ahref.data("conversation"), function (html: any) {
				modal.find(".modal-body").html(html);
			});
		});
	}
});